import essoxLogoFooter from '@/images/clients/essox-logo.png'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

const hosts = [
  'www.essoxpojisteni.cz',
  'essoxpojisteni.cz'
  //, 'localhost:44470'
]

export const Essox: IPartnerSettings = {
  partner: 'Essox',
  deployment: 'Essox',
  hosts: hosts,
  logo: essoxLogoFooter,
  market: Market.CZ
}

export const AutoEsa: IPartnerSettings = {
  partner: 'AutoEsa',
  deployment: 'Essox',
  hosts: hosts,
  logo: essoxLogoFooter,
  market: Market.CZ
}

export const DirectAuto: IPartnerSettings = {
  partner: 'DirectAuto',
  deployment: 'Essox',
  hosts: hosts,
  logo: essoxLogoFooter,
  market: Market.CZ
}
